import './assets/styles/main.css'

import App from './App.vue'
import router from './router'
import Lara from '@/presets/lara';
import PrimeVue from "primevue/config";
import Tooltip from 'primevue/tooltip';
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import { createApp } from 'vue'
import { createPinia } from 'pinia'


const app = createApp(App)

app.use(createPinia())
app.use(router)


app.use(PrimeVue, {
    unstyled: true,
    ripple: true,
    pt: Lara
})
app.use(ToastService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);

app.mount('#app')